import {CreateResult, CreateResultSummary} from "../view-model";
import {ClientEntity} from "@common-core/coat-operational-hierarchy-appsync-model";

export const summarizeResult = (
  source: ClientEntity,
  result: CreateResult
): CreateResultSummary => {
  const mapped = source.mappedOperationalEntities?.length ?? 0;
  return {
    created: result.status === "created" ? result : undefined,
    mapped: result.status === "created" ? mapped + 1 : mapped,
    failed: result.status === "failed" ? result : undefined
  };
};
